<template>
  <v-container grid-list-md>
    <h1 style="font-size:40px;color: #48445E;">Experience</h1>
    <br /><br />
    <v-row data-aos="fade-up">
      <v-col md="6">
        <div class="study">
          <h1>Education</h1>
          <br />
          <div class="detailExperience">
            <div>
              <img src="@/assets/graduation-cap.png" />
              <div class="line"></div>
            </div>
            <div>
              <h3>Thanyarat School 2010-2015</h3>
              <p>Science-Math GPAX : 2.99</p>
            </div>
          </div>
          <div class="detailExperience">
            <img src="@/assets/graduation-cap.png" />
            <div>
              <h4>Rajamangala University of Technology Thanyaburi 2016</h4>
              <p>
                Bachelor of Engineering Major <br />
                Computer Engineering GPAX : 2.78
              </p>
            </div>
          </div>
        </div>
      </v-col>
      <v-col md="6">
        <div class="study">
          <h1>Internship</h1>
          <br />

          <div class="detailExperience">
            <div>
              <img src="@/assets/suitcase.png" />
              <div class="line"></div>
            </div>
            <div>
              <h4>Aware Technology Solution Software Developer Internship</h4>
              <h4>November 2019 to March 2019</h4>
              <p>
                Front-end Development with Angular Framework Handled REST Api
                (Using Node.js)
              </p>
              <!-- <a href="#intern">intern's project</a> -->
            </div>
          </div>

          <div class="detailExperience">
            <img src="@/assets/suitcase.png" />
            <div>
              <h3>ICT Rajamangala University of Technology Thanyaburi</h3>
              <p>
                Web Developer with Wordpress and Graphic Design for Production
                of Advertising Media of University
              </p>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <br /><br />
    <h1 class="interWorkshop">International Workshop</h1>
    <br />
    <v-row>
      <v-col md="12">
        <div class="workshop text-center">
          <img src="@/assets/japan.png" width="50" />
          <h1>WEB DESIGN CONTEST 2019</h1>
          <h3>
            Hokkaido Information University X Rajamangala University Technology
            of Thanyaburi
          </h3>
          <h4>
            I worked with japanese ux/ui desinger. I'm web creator of team, see
            our website <a href="#kishiweb">Click!</a>
          </h4>
          <v-row
            data-aos="fade-up"
            class="d-flex flex-md-wrap justify-center rowy"
          >
            <v-col class="column tk1">
              <img src="@/assets/line_1568443650901.jpg" />
            </v-col>
            <v-col class="column tk2">
              <img src="@/assets/line_355912539010218.jpg" />
            </v-col>
            <v-col class="column tk3">
              <img src="@/assets/line_433185812908709.jpg" />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="12">
        <div class="workshop text-center">
          <img src="@/assets/south-korea.png" width="50" />
          <h1>GLOBAL CAPSTONE DESIGN PROJECT 2019</h1>
          <h3 class="d-flex align-center justify-center winner">
            <img
              src="@/assets/winner.png"
              width="50"
              style="margin-right:10px"
            />First Place Best Manufacturing Award GCDP 2019 IoT for better
            life. Project is a Smart Luggage
          </h3>
          <h5>
            yeungnam university X Rajamangala University Technology of
            Thanyaburi
          </h5>
          <v-row
            data-aos="fade-up"
            class="d-flex flex-md-wrap justify-center rowy"
          >
            <v-col md="5" class="column gcdp1">
              <img src="@/assets/gcdp1_1.jpg" />
            </v-col>
            <v-col class="column ">
              <img src="@/assets/gcdp1_2.jpg" />
              <img src="@/assets/gcdp1_4.jpg" />
            </v-col>
            <v-col class="column gcdp4">
              <img src="@/assets/gcdp1_3.jpg" />
            </v-col>
            <v-col class="column gcdp6">
              <!-- <div class="alt"></div> -->
              <img src="@/assets/gcdp_6.jpg" />
            </v-col>
            <v-col class="column gcdp7">
              <!-- <div class="alt"></div> -->
              <img src="@/assets/gcdp_7.jpg" />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="12">
        <div class="workshop text-center">
          <img src="@/assets/south-korea.png" width="50" />
          <h1>E-Festa 2019</h1>
          <h3>
            Engineering Project Festival at Incheon
          </h3>
          <v-row
            data-aos="fade-up"
            class="d-flex flex-md-wrap justify-center rowy"
          >
            <v-col class="column ef1">
              <img src="@/assets/ef2.jpg" />
            </v-col>
            <v-col class="column  ef2">
              <img src="@/assets/ef4.jpg" />
            </v-col>
            <v-col md="5" class="column eflast">
              <img src="@/assets/ef1.jpg" />
            </v-col>
            <v-col md="5" class="column eflast">
              <img src="@/assets/ef3.jpg" />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
export default {
  components: {
    // Hooper,
    // Slide,
    // HooperNavigation,
  },
};
</script>

<style scoped>
.alt {
  width: 100%;
  height: 100%;
  background: rgba(100, 212, 100, 0.445);
  z-index: 2;
}
.rowy {
  display: flex;
  flex-wrap: wrap;
  padding: 5em 4px 5em 0;
}
/* .gcdp1{
  width: 300px ;
}  */
.column img {
  margin-top: 8px;
  vertical-align: middle;
  width: 100%;
}
.column {
  flex: 26.5%;
  max-width: 26.5%;
  padding: 0 4px;
}
.gcdp1 {
  flex: 40%;
  max-width: 40%;
  padding: 0 4px;
}
.ef1 {
  flex: 63%;
  max-width: 63.5%;
  padding: 0 3px;
}
.ef2 {
  flex: 36%;
  max-width: 36%;
  padding: 0 4px;
}
.eflast {
  flex: 50%;
  max-width: 50%;
  padding: 0 4px;
}
.tk1 {
  flex: 56%;
  max-width: 56%;
  padding: 0 2px;
}
.tk2 {
  flex: 42%;
  max-width: 42.5%;
  padding: 0 4px;
}
.tk3 {
  flex: 100%;
  max-width: 100%;
  padding: 0 10px;
}
.gcdp6 {
  flex: 72%;
  max-width: 71%;
  padding: 0 4px;
}
.gcdp7 {
  flex: 26%;
  max-width: 26%;
  padding: 0 4px;
}
.gcdp4 {
  flex: 30.2%;
  max-width: 30.2%;
  padding: 0 4px;
}

.workshop {
  height: auto;
  color: #48445e;
}
.study {
  width: 100%;
  min-height: 400px;
  height: 100%;
  background: white;
  box-shadow: 0px 0px 25px rgba(128, 128, 128, 0.158);
  border-radius: 20px;
  padding: 2em;
  color: #48445e;
}
.interWorkshop {
  color: #48445e;
}
.detailExperience {
  display: flex;
  align-items: flex-start;
  text-align: left;
}
.detailExperience img {
  width: 30px;
  height: 30px;
  margin-right: 1em;
}
.detailExperience div:nth-child(1) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.line {
  min-height: 100px;
  height: 100%;
  width: 2px;
  background: #fd355694;
  margin-right: 1em;
}
/* Responsive layout - makes a two column-layout instead of four columns */
/* @media screen and (max-width: 800px) {
  .column {
    flex: 50%;
    max-width: 50%;
  }
} */

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px), (max-width: 800px) {
  .column {
    flex: 100%;
    max-width: 100%;
  }
  .winner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .interWorkshop {
    font-size: 25px;
    text-align: center;
  }
  .line {
    display: none;
  }
}
</style>
